"use strict";


class UserOverviewCtrl {


    constructor($scope, $state, $rootScope, $http, User, $mdDialog, $mdToast, paginationService, $sanitize, $transitions) {

        // Dependencies
        this.$state = $state;
        this.$http = $http;
        this.$mdDialog = $mdDialog;
        this.$mdToast = $mdToast;
        this.paginationService = paginationService;
        this._User = User;

        // Controller vars
        this.maxreached = true;
        this.$sanitize = $sanitize;

        // Paginator
        this.pagination = {
            current: 1
        };

        // Watchers
        $rootScope.checkActive = (user) => {
            return user.id == $state.params.id;
        };

        let unregister = $transitions.onSuccess({ }, function(transition) {

            let toState = transition.to();
            if (toState.name === 'user') {
                this.fetch();
            }
        });

        $scope.$on('$destroy', () => {
            unregister();
        });

        // Fetch overview items
        if ($state.params.id) {
            $http.get('/users/findpage/' + $state.params.id).then((response) => {
                this.fetch(response.data);
                this.pagination.current = response.data;
            });
        } else {
            this.fetch(1);
        }
    }

    fetch(pageNumber) {
        this.$http.get('/users_overview/?page=' + pageNumber)
            .then((response) => {
                this.users = response.data.data;
                this.totalResults = response.data.total;
                this.resultPerPage = response.data.per_page;
                this.users.forEach((user) => {
                    user._email = user.email.replace(/\'/g, '\\\'');
                })
            });

        this.$http.get('/station').then((response) => {
            this.adfs = response.data.is_adfs;
        });

        this.pageChanged = function (newPage) {
            getResultsPage(newPage);
        };

        this.$http.get('organisation/user-subscription').then((response) => {
            this.maxreached = response.data.maxReached;
        });
    }


    updateUser(id) {

        window.location.hash = 'user/create/' + id;
    }

    disable(id, firstname, lastname, ev) {

        ev.stopPropagation();

        this.$mdDialog.show({

            controller: 'ConfirmDialogCtrl',
            templateUrl: "confirmDialog.ngTemplate",
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: ev,
            clickOutsideToClose: true
        }).then(() => {

            let deleteId = id || this.$stateParams.userId;
            this._User.delete({id: deleteId}, () => {
                this.$state.go('user', {}, {'reload': true});
            });

            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.delete?object=user&title=' + firstname + '%20' + lastname, //@trans('labels.user')
                hideDelay: 3000,
                position: ('top right')
            });
        });
    }
}


UserOverviewCtrl.$inject = ['$scope', '$state', '$rootScope', '$http', 'User', '$mdDialog', '$mdToast', 'paginationService', '$sanitize', '$transitions'];


module.exports = UserOverviewCtrl;
